import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const IndoorPoolIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "IndoorPoolIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.2938 14.4348C20.1366 15.684 18.6511 15.7638 17.455 14.4427C17.2269 14.188 16.8227 14.1825 16.5881 14.4413C15.4338 15.7175 13.9548 15.7247 12.794 14.4427C12.5659 14.188 12.1618 14.1825 11.9271 14.4413C11.92 14.4491 11.3526 15.0661 10.6121 15.3131V6.09195H17.0209C17.3427 6.09195 17.6036 5.83109 17.6036 5.50933C17.6036 5.18757 17.3427 4.92671 17.0209 4.92671H7.11635V4.34409C7.11635 4.02233 6.85549 3.76147 6.53373 3.76147C6.21197 3.76147 5.95111 4.02233 5.95111 4.34409V4.92671H3.58174V4.34409C3.58174 4.02233 3.32088 3.76147 2.99912 3.76147C2.67736 3.76147 2.4165 4.02233 2.4165 4.34409V20.6575C2.4165 20.9793 2.67736 21.2401 2.99912 21.2401H21.7207C22.0425 21.2401 22.3033 20.9793 22.3033 20.6575V14.8313C22.3033 14.3036 21.6537 14.0474 21.2938 14.4348ZM12.3599 15.6263C13.8408 16.8487 15.4334 16.9368 17.0209 15.6263C18.3306 16.7075 19.6917 16.9015 21.1381 16.0275V16.9132C19.8306 18.0811 18.5598 17.9934 17.455 16.7732C17.2269 16.5185 16.8227 16.513 16.5881 16.7719C15.4338 18.048 13.9548 18.0552 12.794 16.7732C12.5659 16.5185 12.1618 16.5131 11.9271 16.7719C10.771 18.0473 9.29781 18.0565 8.13299 16.7732C7.90297 16.5163 7.4989 16.5151 7.26609 16.7719C6.14108 18.0129 4.86316 18.0624 3.58174 16.9137V16.0275C5.02567 16.9001 6.3873 16.7091 7.69894 15.6263C9.17981 16.8487 10.7723 16.9368 12.3599 15.6263ZM3.58174 14.5831V13.0834H5.95107V15.313C5.0818 15.603 4.26395 15.1947 3.58174 14.5831ZM5.95107 11.9182H3.58174V10.7529H5.95107V11.9182ZM5.95107 9.5877H3.58174V8.42244H5.95107V9.5877ZM9.44681 6.09195V15.3131C8.7063 15.0662 8.13909 14.4494 8.133 14.4426C7.90298 14.1857 7.49891 14.1846 7.2661 14.4413C7.26396 14.4437 7.21021 14.502 7.11637 14.5888V6.09195H9.44681ZM5.95107 6.09195V7.2572H3.58174V6.09195H5.95107ZM3.58174 20.0749V18.3576C5.03488 19.2359 6.39421 19.0338 7.69894 17.9568C9.17981 19.1792 10.7723 19.2673 12.3599 17.9568C13.8408 19.1792 15.4334 19.2673 17.0209 17.9568C18.3262 19.0343 19.6866 19.2349 21.1381 18.3576V20.0749H3.58174Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default IndoorPoolIcon;
